import { Injectable, OnDestroy, signal } from '@angular/core';
import { fetchAuthSession, Hub } from '@aws-amplify/core';
// import { AuthHubEventData, HubCapsule, StopListenerCallback } from '@aws-amplify/core/dist/esm/Hub/types';
import { LoggerService } from '@sko/ng-logging';
import { AuthHubEventData, HubCapsule, StopListenerCallback } from 'node_modules/@aws-amplify/core/dist/esm/Hub/types';

export interface AuthedUser {

  at_hash: string;

  aud: string;

  auth_time: number;

  'cognito:groups': Array<string>;

  'cognito:username': string;

  email: string;

  email_verified: boolean;

  exp: number;

  family_name: string;
  
  given_name: string;
  
  iat: number;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  identities: Array<any>;

  iss: string;

  jti: string;

  nonce: string;

  origin_jti: string;

  picture: string;

  sub: string;

  token_use: string;

}

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {

  private unsubscribe: StopListenerCallback;

  private userSignal = signal<AuthedUser | undefined>(undefined);

  user = this.userSignal.asReadonly();

  constructor(
    private logger: LoggerService,
  ) { 

    this.unsubscribe = Hub.listen('auth', (capsule) => {

      this.onHubEvent(capsule);

    });

    fetchAuthSession()
    .then((session) => {

      this.logger.info({ session }, 'AuthService');

      if (session.tokens?.idToken) {

        const payload = session.tokens.idToken.payload as unknown as AuthedUser;

        this.userSignal.set({
          ...payload
        });
        
        return true;

      } else {

        return true;

      }

    })
    .catch((e) => {

      logger.error(e);

    });

  }

  ngOnDestroy(): void {
    
    this.unsubscribe();

  }

  private onHubEvent(capsule: HubCapsule<'auth', AuthHubEventData>) {

    switch (capsule.payload.event) {
      case 'signedIn':

        this.logger.info('user have been signedIn successfully.');

        fetchAuthSession()
        .then((session) => {

          if (session.tokens?.idToken) {

            const payload = session.tokens.idToken.payload as unknown as AuthedUser

            this.userSignal.set(payload);

          }

        })
        .catch((e) => {

          this.logger.error(e);

          this.userSignal.set(undefined);

        });

        break;
      case 'signedOut':
        this.logger.info('user have been signedOut successfully.');
        break;
      case 'tokenRefresh':
        this.logger.info('auth tokens have been refreshed.');
        break;
      case 'tokenRefresh_failure':
        this.logger.info('failure while refreshing auth tokens.');
        break;
      case 'signInWithRedirect':
        this.logger.info('signInWithRedirect API has successfully been resolved.');
        break;
      case 'signInWithRedirect_failure':
        this.logger.info('failure while trying to resolve signInWithRedirect API.');
        break;
      case 'customOAuthState':
        this.logger.info('custom state returned from CognitoHosted UI');
        break;

    }

  }

}
